export default __webpack_public_path__ + "static/media/gallery-9-4.04fa3e6d.jpg";